export const GET_SECOURISME_SUCCESS = "GET_SECOURISME_SUCCESS";
export const GET_SECOURISME_LOAD = "GET_SECOURISME_LOAD";
export const GET_SECOURISME_FAILD = "GET_SECOURISME_FAILD";
export const GET_ONE_SECOURISME = "GET_ONE_SECOURISME";
